import { useEffect, useState } from "react";
import ImageUpload from "../../components/ImageUpload";
import api, { thumb } from "../../lib/api";

export default function AdminSettings({ ctx }) {
  const { settings, setSettings, saveSettings } = ctx;
  const [creators, setCreators] = useState([]);
  useEffect(() => { api.get("/creators").then(({ data }) => setCreators(data)).catch(() => {}); }, []);
  const selectedIds = settings.featured_creator_ids || [];
  const toggleFeatured = (id) => {
    const next = selectedIds.includes(id)
      ? selectedIds.filter((x) => x !== id)
      : [...selectedIds, id];
    setSettings({ ...settings, featured_creator_ids: next });
  };
  return (
    <div className="mt-10 max-w-2xl space-y-4 bg-white border-2 border-[#121212] p-6">
      <ImageUpload library label="hero image" testid="set-hero" value={settings.hero_image || ""} onChange={(url) => setSettings({ ...settings, hero_image: url })} />
      <ImageUpload library label="studio image" testid="set-studio" value={settings.studio_image || ""} onChange={(url) => setSettings({ ...settings, studio_image: url })} />
      <ImageUpload library label="founder image" testid="set-founder" value={settings.founder_image || ""} onChange={(url) => setSettings({ ...settings, founder_image: url })} />
      <ImageUpload library label="t-shirt add-on image" testid="set-tshirt" value={settings.tshirt_image || ""} onChange={(url) => setSettings({ ...settings, tshirt_image: url })} />

      <div className="pt-4 mt-2 border-t-2 border-[#121212]/10">
        <p className="text-sm tracking-[0.2em] uppercase font-bold text-[#121212]">Parties page photos</p>
        <p className="text-xs text-[#121212]/55 mt-1 mb-3">Leave any slot empty to keep the current default photo.</p>
        <div className="space-y-3">
          <ImageUpload library label="parties — main hero photo" testid="set-parties_hero" value={settings.parties_hero || ""} onChange={(url) => setSettings({ ...settings, parties_hero: url })} />
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#121212]/70 pt-2">Photo gallery (6)</p>
          {[1, 2, 3, 4, 5, 6].map((n) => (
            <ImageUpload key={`pg${n}`} library label={`gallery photo ${n}`} testid={`set-parties_gallery_${n}`} value={settings[`parties_gallery_${n}`] || ""} onChange={(url) => setSettings({ ...settings, [`parties_gallery_${n}`]: url })} />
          ))}
          <p className="text-xs tracking-[0.2em] uppercase font-bold text-[#121212]/70 pt-2">Closing "unforgettable" banner (3)</p>
          {[1, 2, 3].map((n) => (
            <ImageUpload key={`pb${n}`} library label={`banner photo ${n}`} testid={`set-parties_banner_${n}`} value={settings[`parties_banner_${n}`] || ""} onChange={(url) => setSettings({ ...settings, [`parties_banner_${n}`]: url })} />
          ))}
        </div>
      </div>

      <div className="pt-4 mt-2 border-t-2 border-[#121212]/10 space-y-3">
        <p className="text-sm tracking-[0.2em] uppercase font-bold text-[#121212]">Other page photos</p>
        <ImageUpload library label="open studio / classes feature photo" testid="set-open_studio_image" value={settings.open_studio_image || ""} onChange={(url) => setSettings({ ...settings, open_studio_image: url })} />
        <ImageUpload library label="guest creators photo" testid="set-creator_mondays_image" value={settings.creator_mondays_image || ""} onChange={(url) => setSettings({ ...settings, creator_mondays_image: url })} />
      </div>
      <div>
        <label className="text-xs tracking-[0.2em] uppercase font-bold block mb-2">party inquiry notification email</label>
        <input data-testid="set-notify_email" type="email" placeholder="where new party inquiries are emailed" value={settings.notify_email || ""} onChange={e => setSettings({ ...settings, notify_email: e.target.value })} className="w-full px-4 py-3 border-2 border-[#121212] focus:outline-none" />
        <p className="text-xs text-[#121212]/55 mt-1">New party inquiries are emailed here (requires Resend to be active).</p>
      </div>

      <div data-testid="final-details-schedule" className="border-2 border-[#F5A623] p-4">
        <label className="text-xs tracking-[0.2em] uppercase font-bold block mb-2">Final party details email schedule</label>
        <p className="text-xs text-[#121212]/60 mb-3">Booked parties automatically get their "Final Party Details" form email on this day/time the week their party falls on.</p>
        <div className="flex flex-wrap gap-4 items-end">
          <div>
            <label className="text-[11px] tracking-[0.15em] uppercase font-bold block mb-1">Day</label>
            <select data-testid="set-fd-day" value={settings.final_details_email_day ?? 0} onChange={e => setSettings({ ...settings, final_details_email_day: Number(e.target.value) })} className="px-4 py-3 border-2 border-[#121212] focus:outline-none">
              {["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"].map((d, i) => <option key={d} value={i}>{d}</option>)}
            </select>
          </div>
          <div>
            <label className="text-[11px] tracking-[0.15em] uppercase font-bold block mb-1">Time (Central)</label>
            <input data-testid="set-fd-time" type="time" value={settings.final_details_email_time || "09:00"} onChange={e => setSettings({ ...settings, final_details_email_time: e.target.value })} className="px-4 py-3 border-2 border-[#121212] focus:outline-none" />
          </div>
        </div>
      </div>
      <div>
        <label className="text-xs tracking-[0.2em] uppercase font-bold block mb-2">founder name</label>
        <input data-testid="set-founder_name" value={settings.founder_name || ""} onChange={e => setSettings({ ...settings, founder_name: e.target.value })} className="w-full px-4 py-3 border-2 border-[#121212] focus:outline-none" />
      </div>
      <div>
        <label className="text-xs tracking-[0.2em] uppercase font-bold block mb-2">founder bio</label>
        <textarea data-testid="set-founder_bio" rows={4} value={settings.founder_bio || ""} onChange={e => setSettings({ ...settings, founder_bio: e.target.value })} className="w-full px-4 py-3 border-2 border-[#121212] focus:outline-none" />
      </div>
      <div className="pt-4 mt-2 border-t-2 border-[#121212]/10" data-testid="featured-creator-admin">
        <p className="text-sm tracking-[0.2em] uppercase font-bold text-[#121212]">Featured Creator (homepage)</p>
        <p className="text-xs text-[#121212]/55 mt-1 mb-3">
          Select which Guest Creator teacher(s) to spotlight on the homepage. Only accounts you pick here appear —
          nothing shows automatically. Leave all unchecked to hide the section entirely.
          {selectedIds.length > 1 && " Multiple selections rotate every few seconds."}
        </p>
        {creators.length === 0 ? (
          <p className="text-xs text-[#121212]/55">No creator accounts yet.</p>
        ) : (
          <div className="space-y-2">
            {creators.map((c) => {
              const checked = selectedIds.includes(c.id);
              return (
                <label
                  key={c.id}
                  data-testid={`featured-toggle-${c.id}`}
                  className={`flex items-center gap-3 px-3 py-2 border-2 border-[#121212] cursor-pointer transition-colors ${checked ? "bg-[#C6FF33]" : "bg-white hover:bg-[#F2E9D8]"}`}
                >
                  <input
                    type="checkbox"
                    checked={checked}
                    onChange={() => toggleFeatured(c.id)}
                    className="w-4 h-4 accent-[#121212]"
                    data-testid={`featured-checkbox-${c.id}`}
                  />
                  <div className="w-10 h-10 border-2 border-[#121212] overflow-hidden bg-[#A89D8A]/20 shrink-0">
                    {c.photo_url ? <img src={thumb(c.photo_url, 80)} alt={c.name} className="w-full h-full object-cover" /> :
                      <div className="w-full h-full flex items-center justify-center font-serif font-black text-lg text-[#121212]/40">{c.name[0]}</div>}
                  </div>
                  <span className="font-serif font-black text-lg text-[#121212]">{c.name}</span>
                </label>
              );
            })}
          </div>
        )}
        {selectedIds.length === 0 && (
          <p className="text-xs text-[#121212]/70 mt-3 font-bold" data-testid="featured-none-note">
            Nothing selected — the Featured Creator section is hidden on the homepage.
          </p>
        )}
      </div>

      <div data-testid="sales-tax-setting" className="border-2 border-[#121212] p-4">
        <label className="text-xs tracking-[0.2em] uppercase font-bold block mb-2">Sales tax rate</label>
        <p className="text-xs text-[#121212]/60 mb-3">Flat rate applied to taxable items (Merch, Cake/Add-Ons, and Open Studio by default) at checkout. Tax shows separately on receipts and in the Sales Report. Set to 0 to disable.</p>
        <div className="flex items-center gap-2 max-w-[180px]">
          <input data-testid="set-sales_tax_rate" type="number" step="0.01" min="0" value={settings.sales_tax_rate ?? 9} onChange={e => setSettings({ ...settings, sales_tax_rate: e.target.value === "" ? "" : Number(e.target.value) })} className="w-full px-4 py-3 border-2 border-[#121212] focus:outline-none" />
          <span className="font-bold text-[#121212]">%</span>
        </div>
      </div>

      <button data-testid="save-settings-btn" onClick={saveSettings} className="px-8 py-4 bg-[#121212] text-[#F2E9D8] hover:bg-black text-xs tracking-[0.25em] uppercase font-bold">Save settings</button>
    </div>
  );
}
